import { useShopStore } from '../stores/shop'
import { useAuthStore } from '../stores/auth'

export function useShopId() {
  const currentShopId = useAuthStore((s) => s.currentShopId)
  const fallbackShopId = useShopStore((s) => s.shopId)
  return currentShopId || fallbackShopId
}
